<div class="grid-x">
  @if (!showEntityMaps) {
    <div class="cell small-12" style="color: red;">
      Data Context -> Entity mappings must first be created via the Data Configuration tab before this side effect can be configured.
    </div>
  }
  @if (showEntityMaps) {
    <div>
      <h5 class="bold">Action Mapping</h5>
      <div class="cell small-12">
        <label>
          Select mappings to add to the action:
        </label>
      </div>
      @for (map of entityMaps; track map) {
        <div class="cell small-12 checkbox">
          <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="map.id" [attr.name]="map.id" (click)="checkChanged(map.id)" [checked]="configHasMapping(map.id)" />
          <label [attr.for]="map.id">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            {{map.mapName}} - Creates Entity of type {{map.entity.entityName}}
          </label>
        </div>
      }
    </div>
  }
</div>